





import { Component, Vue } from 'vue-property-decorator'
import showdown from 'showdown'
import * as readmeContent from '../../../README.md'

@Component({
  components: {}
})
export default class Showdown extends Vue {
  private html: string = ''
  private mounted() {
    const converter = new showdown.Converter()
    this.html = converter.makeHtml(readmeContent)
    // ---------- Markdown custom content -----------
    // const markdownContent: string = '# Markdown Title `showdown.js`'
    // this.html = converter.makeHtml(markdownContent)
  }
}
